import styled, { css } from 'styled-components'
import { ifProp, prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'
import { useIsMobile } from '../../../zustand/browser-store/use-browser-store'

const Content = (props) => {
  const isMobile = useIsMobile()

  return <ContentStyle isMobile={isMobile} {...props} />
}

const ContentStyle = styled.div`
  overflow: ${ifProp('overflowHidden', 'hidden', 'auto')};
  height: 100%;
  position: relative;
  transition: margin-left 0.5s ease;
  @media (max-width: 1024px) {
    margin-left: 0;
  }
  ${ifProp(
    'isMobile',
    css`
      margin-left: 0;
      background: ${colorsOptions.greys.white};
    `,
    css`
      background: ${colorsOptions.greys['grey-10']};
      margin-left: ${prop('left')}px;
    `
  )}
`

export default Content
